import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=2e7531d3&scoped=true"
import script from "./ResourceList.vue?vue&type=script&lang=js"
export * from "./ResourceList.vue?vue&type=script&lang=js"
import style0 from "./ResourceList.vue?vue&type=style&index=0&id=2e7531d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7531d3",
  null
  
)

export default component.exports